export const LICENSE_FEATURES_SDMX = "Sdmx";
export const LICENSE_FEATURES_OPENDATA = "Opendata";
export const LICENSE_FEATURES_GEODATA = "Geodata";
export const LICENSE_FEATURES_AI = "AI";
